import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Grid,
  Tooltip,
  Fade,  
  SvgIcon,  
} from '@material-ui/core'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import CreditCardIcon from '@material-ui/icons/CreditCard'
import ReplyIcon from '@material-ui/icons/Reply'
import ReplyAllIcon from '@material-ui/icons/ReplyAll'
import LocalAtmOutlinedIcon from '@material-ui/icons/LocalAtmOutlined'
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'

const useStyles = makeStyles(theme => ({    
  helpDark: {    
    marginLeft: 4,
    fontSize: 13,
    color: 'rgba(255, 255, 255, 0.5)'
  },
  help: {
    marginLeft: 4,
    fontSize: 13,
    color: 'rgba(0, 0, 0, 0.5)'
  },
  tooltip: {
    maxWidth: 250,
    textAlign: 'center',
    fontSize: '12px',
    [theme.breakpoints.down('lg')]: {
      fontSize: '10px',
    }
  }
}))

function CashSolidIcon(props) {
  return(
    <SvgIcon {...props}>
      <path fill="currentColor" d="M20 4H4C2.89 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.1 4 20 4M15 10H11V11H14C14.55 11 15 11.45 15 12V15C15 15.55 14.55 16 14 16H13V17H11V16H9V14H13V13H10C9.45 13 9 12.55 9 12V9C9 8.45 9.45 8 10 8H11V7H13V8H15V10Z" />
    </SvgIcon>
  )
}

export default function Stats(props) {  
  const { dark } = props
  const { Cost, Mailed, Responses, Sales, HO_Count, HO_Resp } = props.data
  const classes = useStyles()
  const statItems = [
    {
      groupOne: {        
        icon: <CreditCardIcon className="roi-card-icon" style={{color: `${dark ? "#fc7272" : "#ff4a4a"}`}}/>,
        label: 'Spend',
        border: dark ? "#fc7272" : "#ff4a4a",
        // colors: ['#f56d64', '#f05a4f'],
        data: Cost ? '$' + Math.round(Cost).toLocaleString('en') : '$0',
        info: 'Total cost of mailing',
        timeout: 100,
      },
      groupTwo: {
        icon: <MailOutlineIcon className="roi-card-icon" style={{color: `${dark ? "#c58fff" : "#993bff"}`}}/>,
        label: 'Mailed',
        border: dark ? "#c58fff" : "#993bff",
        // colors: ['#ad80ed', '#ad64de'],
        data: Mailed ? Math.round(Mailed).toLocaleString('en') : 0,
        info: 'Total quantity of pieces mailed',
        timeout: 700
      }
    },
    {
      groupOne: {        
        icon: <ReplyAllIcon className="roi-card-icon" style={{color: `${dark ? "#4ed4fc" : "#19beff"}`}}/>,
        label: 'Responses',
        border: dark ? "#4ed4fc" : "#19beff",
        // colors: ['#3dbde3', '#23b0db'],
        data: Responses ? Math.round(Responses).toLocaleString('en') : '0',
        info: 'Total number of orders placed by everyone mailed during the promotional window',
        subdata: Mailed ? ((Responses / Mailed) * 100).toFixed(1) + '%' : '0%',
        timeout: 250
      },
      groupTwo: {
        icon: <ReplyIcon className="roi-card-icon" style={{color: `${dark ? "#ff8ffe" : "#d932d7"}`}}/>,
        label: 'Incremental Responses',
        border: dark ? "#ff8ffe" : "#d932d7",
        // colors: ['#d669d4', '#e65ae4'],
        data: HO_Count > 0 ? (Responses / Mailed) - (HO_Resp / HO_Count) > 0 ? Math.round(Mailed * ((Responses / Mailed) - (HO_Resp / HO_Count))).toLocaleString('en') : 0 : Responses / Mailed,
        info: 'Total number of orders placed scaled down based on the relative performance of the holdout group compared to the mailed group',
        subdata: HO_Count > 0 ? (Responses / Mailed) - (HO_Resp / HO_Count) > 0 ? ((Responses / Mailed) / (HO_Resp / HO_Count)).toFixed(1) + 'x' : '0x' : null,
        timeout: 850
      }
    },
    {
      groupOne: {        
        icon: <CashSolidIcon className="roi-card-icon" style={{color: `${dark ? "#92e635" : "#5fb500"}`}}/>,
        label: 'Sales',
        border: dark ? "#92e635" : "#5fb500",
        // colors: ['#84cf30', '#6cad23'],
        data: Sales ? '$' + Math.round(Sales).toLocaleString('en') : '$0',
        info: 'Total revenue generated by everyone mailed during the promotional window',
        timeout: 400
      },
      groupTwo: {
        icon: <LocalAtmOutlinedIcon className="roi-card-icon" style={{color: `${dark ? "#f0e043" : "#d6a800"}`}}/>,
        label: 'Incremental Sales',
        border: dark ? "#f0e043" : "#d6a800",
        // colors: ['#e6d31c', '#bfaf13'],
        data: HO_Count > 0 ? (Responses / Mailed) - (HO_Resp / HO_Count) > 0 ? "$" + Math.round((Sales / (Responses / Mailed)) * ((Responses / Mailed) - (HO_Resp / HO_Count))).toLocaleString('en') : "$0" : "$" + Math.round(Sales / (Responses / Mailed)).toLocaleString("en"),
        info: 'Total revenue scaled down based on the relative performance of the holdout group compared to the mailed group',
        timeout: 1000
      }
    },
    {
      groupOne: {        
        icon: <MonetizationOnIcon className="roi-card-icon" style={{color: `${dark ? "#04c9b5" : "#00a695"}`}} />,
        label: 'ROAS',
        border: dark ? "#04c9b5" : "#00a695",
        // colors: ['#32cfbf', '#14a899'],
        data: Cost > 0 ? '$' + (Sales / Cost).toFixed(2) :  '$0',
        info: 'Revenue generated for each dollar spent on advertising',
        timeout: 550
      },
      groupTwo: {
        icon: <MonetizationOnOutlinedIcon className="roi-card-icon" style={{color: `${dark ? "#ff9766" : "#e3662b"}`}}/>,
        label: 'Incremental ROAS',
        border: dark ? "#ff9766" : "#e3662b",
        // colors: ['#ed8251', '#db7342'],
        data: HO_Count > 0 ? (Responses / Mailed) - (HO_Resp / HO_Count) > 0 ? '$' + ((Sales / (Responses / Mailed)) * ((Responses / Mailed) - (HO_Resp / HO_Count)) / Cost).toFixed(2) : "$0" : '$' + (Sales / Cost).toFixed(2),
        info: 'Incremental revenue generated for each dollar spent on advertising',
        timeout: 1150
      }
    },
  ]

  return(
    <div className="roi-stats">
      <Grid
        container
        justify='space-between'
        spacing={3}
        columns={{xs: 1, sm: 1, md: 4, lg: 4, xl: 4}}        
      >
        {statItems.map(({groupOne, groupTwo}, i) => (
          <Grid key={i} item xs={12} sm={12} md={3} lg={3} xl={3}>
            <Fade in={true} timeout={groupOne.timeout}>
              <Card className={`card ${dark ? "card-dk" : "card-lt"}`} style={{border: `2px solid ${groupOne.border}`}}>
                <CardMedia>                                 
                    {groupOne.icon}                  
                </CardMedia>
                <CardContent className="card-content">
                  <Typography className="title" style={{color: `${groupOne.border}`}}>
                    {groupOne.label}
                    <Tooltip classes={{tooltip: classes.tooltip}} title={groupOne.info} placement="top">
                      <InfoOutlinedIcon fontSize="small" className={dark ? classes.helpDark : classes.help} />
                    </Tooltip>
                  </Typography>
                  <Typography className={`stats ${dark ? "content-dk" : "content-lt"}`}>
                    {groupOne.data}
                  </Typography>
                  <Typography className="sub-stat">
                    {groupOne.subdata ? groupOne.subdata : null}
                  </Typography>
                </CardContent>
              </Card>
            </Fade>

            <Fade in={true} timeout={1000} style={{transitionDelay: '150ms'}}>
              <Card className={`card ${dark ? "card-dk" : "card-lt"}`} style={{border: `2px solid ${groupTwo.border}`, marginTop: '25px'}}>
                <CardMedia className="media">                                    
                  {groupTwo.icon}                  
                </CardMedia>
                <CardContent className="card-content">
                  <Typography className="title" style={{color: `${groupTwo.border}`}}>
                    {groupTwo.label}
                    <Tooltip classes={{tooltip: classes.tooltip}} title={groupTwo.info} placement="top">
                      <InfoOutlinedIcon fontSize="small" className={dark ? classes.helpDark : classes.help} />
                    </Tooltip>
                  </Typography>
                  <Typography className={`stats ${dark ? "content-dk" : "content-lt"}`}>
                    {groupTwo.data}
                  </Typography>
                  <Typography className="sub-stat">
                    {groupTwo.subdata ? groupTwo.subdata : null}
                  </Typography>
                </CardContent>
              </Card>
            </Fade>
          </Grid>
        ))}
      </Grid>
      <br/>
      <Typography align="center" className={`roi-statement ${dark ? "content-dk" : "content-lt"}`}>
        On completed promotions, a total spend of <span style={{color: `${dark ? "#fc7272" : "#ff4a4a"}`}}>${Math.round(Cost).toLocaleString("en")}</span> has yielded <span style={{color: `${dark ? "#92e635" : "#5fb500"}`, fontWeight: "bold"}}>${Math.round(Sales).toLocaleString("en")}</span> in sales to responders (at a {(Responses / Mailed * 100).toFixed(1)}% response rate).<br/>
        Of the sales to responders, <span style={{color: `${dark ? "#f0e043" : "#d6a800"}`, fontWeight: "bold"}}>${Math.round(Sales / (Responses / Mailed) * ((Responses / Mailed) - (HO_Resp / HO_Count))).toLocaleString("en")}</span> are purely incremental 
      </Typography>
    </div>
  )
}
